import { ExternalLinkIcon } from "lucide-react";

export default function TermsOfService() {
  return (
    <div className="sm:mt-36 p-5 mt-16 mb-16 flex flex-col gap-10">
      <h1 className="font-montserrat font-medium text-xl sm:text-2xl capitalize">
        Terms of Service
      </h1>
      <p className="sm:text-md text-sm">
        Welcome to Amadeus Sabra! These terms and conditions
        outline the rules for using our website and
        purchasing our products. By accessing or using our
        site, you agree to these terms. If you don't agree,
        please don't use our site.
      </p>
      <div className="flex flex-col gap-5">
        <h3 className="font-bold">Using Our Website</h3>
        <ul className="gap-1 flex flex-col pl-5">
          <li className="sm:text-md text-sm">
            - You must be at least the age of majority in
            your area to use this site.
          </li>
          <li className="sm:text-md text-sm">
            - Don't use our site for anything illegal or
            unauthorized.
          </li>
          <li className="sm:text-md text-sm">
            - Don't try to harm our site with viruses or
            malicious code.
          </li>
        </ul>
      </div>
      <div className="flex flex-col gap-5">
        <h3 className="font-bold">Product Information</h3>
        <ul className="gap-1 flex flex-col pl-5">
          <li className="sm:text-md text-sm">
            - We try to provide accurate information about
            our products, but we can’t guarantee it's always
            perfect.
          </li>
          <li className="sm:text-md text-sm">
            - Prices and availability may change without
            notice.
          </li>
          <li className="sm:text-md text-sm">
            - We reserve the right to limit sales or cancel
            orders if needed.
          </li>
        </ul>
      </div>
      <div className="flex flex-col gap-5">
        <h3 className="font-bold">Orders and Payments</h3>
        <ul className="gap-1 flex flex-col pl-5">
          <li className="sm:text-md text-sm">
            - You agree to provide accurate and complete
            information when placing an order.
          </li>
          <li className="sm:text-md text-sm">
            - We may refuse or cancel orders at our
            discretion.
          </li>
          <li className="sm:text-md text-sm">
            - Payment is processed securely, but we’re not
            responsible for issues with third-party payment
            processors.
          </li>
        </ul>
      </div>
      <div className="flex flex-col gap-5">
        <h3 className="font-bold">Returns and Refunds</h3>
        <p className="sm:text-md text-sm">
          Please review our Return Policy for details on
          returns and refunds.
        </p>
      </div>
      <div className="flex flex-col gap-5">
        <h3 className="font-bold">
          Third-Party Tools and Links
        </h3>
        <p className="sm:text-md text-sm">
          We may provide access to third-party tools or
          links. Use them at your own risk—we’re not
          responsible for their content or actions.
        </p>
      </div>
      <div className="flex flex-col gap-5">
        <h3 className="font-bold">
          User Comments and Feedback
        </h3>
        <ul className="gap-1 flex flex-col pl-5">
          <li className="sm:text-md text-sm">
            - If you send us comments, feedback, or ideas,
            we can use them without owing you anything.
          </li>
          <li className="sm:text-md text-sm">
            - Don't send anything offensive, illegal, or
            harmful.
          </li>
        </ul>
      </div>
      <div className="flex flex-col gap-5">
        <h3 className="font-bold">Prohibited Uses</h3>
        <p className="sm:text-md text-sm">
          Don’t use our site to:
        </p>
        <ul className="gap-1 flex flex-col pl-5">
          <li className="sm:text-md text-sm">
            - Break any laws.
          </li>
          <li className="sm:text-md text-sm">
            - Harass or discriminate against others.
          </li>
          <li className="sm:text-md text-sm">
            - Spread viruses or spam.
          </li>
          <li className="sm:text-md text-sm">
            - Steal or misuse our content.
          </li>
        </ul>
      </div>
      <div className="flex flex-col gap-5">
        <h3 className="font-bold">Disclaimer</h3>
        <p className="sm:text-md text-sm">
          We provide our site and products “as is.”
        </p>
        <ul className="gap-1 flex flex-col pl-5">
          <li className="sm:text-md text-sm">
            - We don’t guarantee they’ll always be perfect
            or available.
          </li>
          <li className="sm:text-md text-sm">
            - We’re not liable for any damages from using
            our site or products.
          </li>
        </ul>
      </div>
      <div className="flex flex-col gap-5">
        <h3 className="font-bold">
          Changes to These Terms
        </h3>
        <p className="sm:text-md text-sm">
          We may update these terms at any time. Check this
          page regularly for changes. By continuing to use
          our site, you agree to the updated terms.
        </p>
      </div>
      <div className="flex flex-col gap-5">
        <h3 className="font-bold">Governing Law</h3>
        <p className="sm:text-md text-sm">
          These terms are governed by the laws of Lebanon.
        </p>
      </div>
      <div className="flex flex-col gap-5">
        <h3 className="font-bold">
          Contact Us If you have questions
        </h3>

        <p className="flex gap-2 flex-col pl-5">
          <a
            href="mailto:support@amadeussabra.com"
            className="hover:underline flex gap-1 w-fit items-center"
            target="_blank"
            rel="noreferrer"
          >
            <span>support@amadeussabra.com</span>
            <ExternalLinkIcon className="h-3 w-3" />
          </a>
          <a
            href="tel:+9613976780"
            className="hover:underline flex gap-1 w-fit items-center"
            target="_blank"
            rel="noreferrer"
          >
            <span>+961 3 976 780</span>
            <ExternalLinkIcon className="h-3 w-3" />
          </a>
        </p>
      </div>
    </div>
  );
}
